"use script";

const getQuantity = (value) => {
  const regex = /(\d+? lbs)/;
  const match = value.match(regex);

  if (match) {
    return match[1];
  } else {
    return "";
  }
};

const getStoneSize = (value) => {
  const regex = /(\d*?\.?\d+? in\. \- \d*?\.?\d+? in\.)/;
  const match = value.match(regex);

  if (match) {
    return match[1];
  } else {
    return "";
  }
};

const addProductToCart = async (productId, quantity = 1, orderDetails) => {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: productId, // Shopify variant ID
        quantity: quantity,
        properties: {
          "Stone Size": orderDetails.stoneSize,
          State:
            orderDetails.destination[0].toUpperCase() +
            orderDetails.destination.slice(1),
          "Shipping Option":
            orderDetails.shippingOption[0].toUpperCase() +
            orderDetails.shippingOption.slice(1),
        },
      }),
    });

    if (!response.ok) {
      throw new Error("Failed to add product to cart");
    }

    const updatedCart = await response.json();

    return updatedCart;
  } catch (error) {
    console.error("Error adding product:", error);
    return null;
  }
};

const getLiveCart = async () => {
  try {
    const res = await fetch("/cart.js");
    if (!res.ok) {
      throw new Error("Failed to fetch the live cart");
    }
    const cart = await res.json();

    return cart;
  } catch (error) {
    return null;
  }
};

const getShopifyProductVariantId = async (title) => {
  const res = await fetch(
    "https://pondsgardendepot.codersquad.io/api/v1/shopify-product/get-one",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ productTitle: title }),
    }
  );
  const data = await res.json();

  if (data?.status === "success") {
    const { id, qty } = data?.productIdAndQty;
    return { id, qty };
  } else {
    return null;
  }
};

const getOrderDetails = (
  qtyBtns,
  stoneSizeBtns,
  stateSelector,
  shippingSelector
) => {
  const quantity = getQuantity(
    Array.from(qtyBtns).find((btn) => btn?.checked)?.value
  );
  const stoneSize = getStoneSize(
    Array.from(stoneSizeBtns).find((btn) => btn?.checked)?.value
  );
  const destination = stateSelector.value;
  const shippingOption = shippingSelector.value;

  return { quantity, stoneSize, destination, shippingOption };
};

const updateOrAddProductToCart = async (
  variantId,
  quantity = 1,
  orderDetails
) => {
  try {
    const cart = await getLiveCart();
    if (!cart) return;

    const existingItem = cart.items.find((item) => item.id === variantId);

    let updatedCart;

    if (existingItem) {
      const properties = existingItem?.properties;

      if (properties) {
        if (
          orderDetails.stoneSize.trim() !== properties["Stone Size"].trim() ||
          orderDetails.destination.trim().toLowerCase() !==
            properties["State"].trim().toLowerCase()
        ) {
          updatedCart = await addProductToCart(
            variantId,
            quantity,
            orderDetails
          );
        } else {
          // Update quantity
          const newQuantity = existingItem.quantity + quantity;
          const updateResponse = await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              updates: {
                [variantId]: newQuantity,
              },
            }),
          });
          if (!updateResponse.ok)
            throw new Error("Failed to update cart quantity");

          updatedCart = await updateResponse.json();
        }
      }
    } else {
      // Step 3: Add product if not in cart
      updatedCart = await addProductToCart(variantId, quantity, orderDetails);
    }

    // Step 4: Refresh the page if the update or add was successful
    if (updatedCart) {
      localStorage.setItem("cartShouldOpen", "true");
      window.location.reload();
    }

    return updatedCart;
  } catch (error) {
    console.error("Error updating or adding product:", error);
    return null;
  }
};

const getPricing = ({ quantity, destination, stoneSize, shippingOption }) => {
  for (const rule of pricingRules) {
    const destinationMatch = rule.destinations.find(
      (el) => el.toLowerCase().trim() === destination.trim()
    );
    const quantityMatch = rule.quantity.includes(quantity);
    const stoneSizeMatch = rule.stoneSize.includes(stoneSize);
    const shippingOptionMatch = rule.shippingOption.find(
      (el) => el.toLowerCase() === shippingOption.trim()
    );

    if (
      destinationMatch &&
      stoneSizeMatch &&
      quantityMatch &&
      shippingOptionMatch
    ) {
      return rule;
    }
  }
};

const getCurProductAndOrderDetails = (
  qtyBtns,
  stoneSizeBtns,
  stateSelector,
  shippingSelector
) => {
  const orderDetails = getOrderDetails(
    qtyBtns,
    stoneSizeBtns,
    stateSelector,
    shippingSelector
  );

  if (
    orderDetails.quantity !== undefined &&
    orderDetails.stoneSize !== undefined &&
    orderDetails.destination !== undefined &&
    orderDetails.shippingOption !== undefined
  ) {
    const curProduct = getPricing({
      quantity: orderDetails.quantity,
      stoneSize: orderDetails.stoneSize,
      destination: orderDetails.destination,
      shippingOption: orderDetails.shippingOption,
    });

    return { curProduct, orderDetails };
  }
};

const initCustomPricing = (defaultPrice) => {
  document.addEventListener("DOMContentLoaded", function () {
    // init vars
    let curProduct, orderDetails;
    let defaultProductPrice = defaultPrice;

    // html dom elements
    const unavailableAlert = document.querySelector("#unavailable-alert");
    const unavailableQtyAlert = document.querySelector(
      "#unavailable-quantity-alert"
    );
    const cartDrawer = document.getElementById("cart-drawer");
    const cartDrawerCloseBtn = document.querySelector(".drawer__close-btn");
    const qtyBtns = document.querySelectorAll(
      'input.opt-btn[name^="template--"][name$="__main-select-quantity-option"]'
    );
    const stoneSizeBtns = document.querySelectorAll(
      'input.opt-btn[name^="template--"][name$="__main-select-stone-size-option"]'
    );
    const stateSelector = document.querySelector("#state-selector-custom");
    const shippingSelector = document.querySelector(
      "#shipping-option-selector-custom"
    );
    const addToCartBtn = document.querySelector(
      'button[data-add-to-cart-text="Add to cart"][name="add"]'
    );
    const plusBtn = document.querySelector(
      "button.qty-input__btn.btn.btn--plus"
    );
    const orderQty = document.querySelector('input[name="quantity"]');

    // check local storage
    const shouldCartOpen = localStorage.getItem("cartShouldOpen");
    if (shouldCartOpen === "true") {
      cartDrawer.setAttribute("open", "");
      localStorage.setItem("cartShouldOpen", "false");
    } else if (shouldCartOpen === "false") {
      cartDrawer.removeAttribute("open", "");
    }

    // cart close btn event listener
    cartDrawerCloseBtn.addEventListener("click", (e) => {
      e.preventDefault();
      cartDrawer.removeAttribute("open");
    });

    // function to set price
    const setPrice = (curProduct) => {
      let value;

      if (!curProduct) {
        value = defaultProductPrice;
      } else if (curProduct.price) {
        value = curProduct.price;
      }

      setTimeout(() => {
        const curPrice = document.querySelector("strong.price__current");
        curPrice.textContent = value;
      }, 300);
    };

    // function to handle red alert
    const handleUnavailableAlert = (curProduct, orderDetails) => {
      const { quantity, stoneSize, destination, shippingOption } = orderDetails;
      const hasAllDetails =
        quantity && stoneSize && destination && shippingOption;

      if (hasAllDetails) {
        if (!curProduct || curProduct?.price === "Not available") {
          unavailableAlert.classList.add("show-alert");
        } else {
          unavailableAlert.classList.remove("show-alert");
        }
      }
    };

    // function to enable/disable add cart btn
    const handleAddCartBtnVisiblity = (curProduct, orderDetails) => {
      const { quantity, stoneSize, destination, shippingOption } = orderDetails;

      const hasAllDetails =
        quantity && stoneSize && destination && shippingOption;

      if (
        !curProduct ||
        curProduct?.price === "Not available" ||
        !hasAllDetails
      ) {
        if (addToCartBtn) {
          addToCartBtn.classList.add("disabled-element");
        }
      } else {
        if (addToCartBtn && hasAllDetails) {
          addToCartBtn.classList.remove("disabled-element");
        }
      }
    };

    // function to handle alert, add cart btn and setting price combined
    const handleAlertAddCartBtnPriceFunc = () => {
      unavailableQtyAlert.classList.remove("show-quantity-alert");
      ({ curProduct, orderDetails } = getCurProductAndOrderDetails(
        qtyBtns,
        stoneSizeBtns,
        stateSelector,
        shippingSelector
      ));

      if (curProduct?.quantity?.includes("1000 lbs")) {
        document.querySelector('input[name="quantity"]').value = 1;
        plusBtn.disabled = true;
      } else {
        plusBtn.disabled = false;
      }

      handleUnavailableAlert(curProduct, orderDetails);
      handleAddCartBtnVisiblity(curProduct, orderDetails);
      setPrice(curProduct);
    };

    // initially handling
    handleAlertAddCartBtnPriceFunc();

    // handling when order specs change
    qtyBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        handleAlertAddCartBtnPriceFunc();
      });
    });
    stoneSizeBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        handleAlertAddCartBtnPriceFunc();
      });
    });
    shippingSelector.addEventListener("change", () => {
      handleAlertAddCartBtnPriceFunc();
    });
    stateSelector.addEventListener("change", () => {
      handleAlertAddCartBtnPriceFunc();
    });

    // add to cart functionality
    if (addToCartBtn) {
      addToCartBtn.addEventListener("click", async (e) => {
        e.preventDefault();
        unavailableQtyAlert.classList.remove("show-quantity-alert");

        ({ curProduct, orderDetails } = getCurProductAndOrderDetails(
          qtyBtns,
          stoneSizeBtns,
          stateSelector,
          shippingSelector
        ));

        if (!curProduct || curProduct.price === "Not available") return;

        const { id, qty } = await getShopifyProductVariantId(
          curProduct?.shopifyTitle
        );

        if (!id) {
          return;
        }

        const placedOrderQty = parseInt(orderQty.value);

        if (qty < placedOrderQty) {
          unavailableQtyAlert.classList.add("show-quantity-alert");
          addToCartBtn.classList.add("disabled-element");
          return;
        }

        try {
          await updateOrAddProductToCart(id, placedOrderQty, orderDetails);
        } catch (error) {
          console.log(error);
        }
      });
    }
  });
};
